/**
 * BarraInferior — navegación del celular de SOA 10 PRO (brand book §11, detrás de ff_pwa_nav).
 * < 768 px: Mi Día · Triage · Crear (ícono grande) · Agenda · Yo. Activo: ícono en píldora #CFFAFE y
 * etiqueta 800. 84 px de alto + safe-area. «Yo» abre PantallaYo (perfil y todo lo personal; desde ahí, «Ver todo el OS» abre el menú lateral).
 * «Crear» abre el mismo modal de Nueva tarea de siempre.
 */
import { NavLink, useLocation } from "react-router-dom";
import { useFlag } from "../../lib/useFlags.js";

const Icono = ({ n, size = 24 }) => <span className="msr" aria-hidden="true" style={{ fontSize: size }}>{n}</span>;

export default function BarraInferior({ onYo, chat }) {
  // Luz del Chat: rojo si me mencionaron, ámbar si escribió un cliente, cian para el resto; late mientras haya algo de los dos primeros.
  const nivel = !chat?.chats ? null : chat.menc > 0 ? "rojo" : chat.cliente > 0 ? "ambar" : "cian";
  const activo = useFlag("ff_pwa_nav");
  const { pathname } = useLocation();
  if (!activo) return null;

  const items = [
    { to: "/inicio", label: "Mi Día", icon: "home" },
    { to: "/chat", label: "Chat", icon: "chat_bubble", badge: chat?.chats || 0, nivel },   // Bandeja/Triage quedó en «Yo»
    { crear: true, label: "Crear", icon: "add" },
    { to: "/agenda", label: "Agenda", icon: "calendar_month" },
    { yo: true, label: "Yo", icon: "person" },
  ];

  const base = "flex flex-1 flex-col items-center justify-center gap-1 text-[12px] text-muted-foreground";
  return (
    <nav aria-label="Navegación principal" data-tour="pwa-barra" className="md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card"
         style={{ height: "calc(84px + env(safe-area-inset-bottom))", paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="flex h-[84px] items-stretch">
        {items.map(it => {
          if (it.crear) return (
            <button key="crear" type="button" aria-label="Crear tarea" data-tour="pwa-crear" className={base}
                    onClick={() => window.dispatchEvent(new CustomEvent("crew-action", { detail: "new-task" }))}>
              <span className="grid h-[46px] w-[46px] place-items-center rounded-2xl bg-foreground text-background"><Icono n="add" size={26} /></span>
            </button>
          );
          if (it.yo) return (
            <button key="yo" type="button" data-tour="pwa-yo" className={base} onClick={onYo}>
              <span className="grid h-8 w-14 place-items-center rounded-full"><Icono n={it.icon} /></span>
              <span className="font-semibold">{it.label}</span>
            </button>
          );
          const on = pathname === it.to || pathname.startsWith(it.to + "/");
          return (
            <NavLink key={it.to} to={it.to} className={base} aria-current={on ? "page" : undefined}>
              <span className="relative grid h-8 w-14 place-items-center rounded-full" style={{ background: on ? "#CFFAFE" : "transparent", color: on ? "#155E75" : "inherit" }}><Icono n={it.icon} />
                {it.badge > 0 && <span className={`absolute right-1.5 top-0 grid h-[18px] min-w-[18px] place-items-center rounded-full px-1 text-[11px] font-extrabold text-white ${it.nivel === "rojo" ? "bg-red-600 animate-pulse motion-reduce:animate-none" : it.nivel === "ambar" ? "bg-amber-600 animate-pulse motion-reduce:animate-none" : "bg-[#0E7490]"}`}>{it.badge > 99 ? "99+" : it.badge}</span>}
              </span>
              <span className={on ? "font-extrabold text-foreground" : "font-semibold"}>{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
